import { render, staticRenderFns } from "./AddViewPage.vue?vue&type=template&id=63d6329d"
import script from "./AddViewPage.vue?vue&type=script&lang=js"
export * from "./AddViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63d6329d')) {
      api.createRecord('63d6329d', component.options)
    } else {
      api.reload('63d6329d', component.options)
    }
    module.hot.accept("./AddViewPage.vue?vue&type=template&id=63d6329d", function () {
      api.rerender('63d6329d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/add-view-page/AddViewPage.vue"
export default component.exports